(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-quick-view"] && !Shopify.designMode) return;
  try {
    (function () {
    var triggers = document.querySelectorAll('[data-quick-view-index], [data-quick-view-handle]');
    var overlay = document.getElementById('quick-view');
    if (!overlay || !triggers.length) return;

    window.HW = window.HW || {};
    window.HW.closeQuickView = function () {
      if (overlay.classList.contains('is-open')) close();
    };

    var dataEl = document.getElementById('quick-view-data');
    var products = [];
    if (dataEl) {
      try {
        products = JSON.parse(dataEl.textContent);
      } catch (e) {
        products = [];
      }
    }
    if (!products.length) return;

    var backdrop = document.getElementById('quick-view-backdrop');
    var card = document.getElementById('quick-view-card');
    var scrollEl = document.getElementById('quick-view-scroll');
    var closeBtn = document.getElementById('quick-view-close');
    var galleryTrack = document.getElementById('quick-view-gallery');
    var dotsEl = document.getElementById('quick-view-dots');
    var controlsEl = document.getElementById('quick-view-gallery-controls');
    var prevBtn = document.getElementById('quick-view-prev');
    var nextBtn = document.getElementById('quick-view-next');
    var titleEl = document.getElementById('quick-view-title');
    var priceEl = document.getElementById('quick-view-price');
    var descEl = document.getElementById('quick-view-description');
    var optionsEl = document.getElementById('quick-view-options');
    var errorEl = document.getElementById('quick-view-error');
    var submitBtn = document.getElementById('quick-view-submit');
    var detailsAccordion = document.getElementById('quick-view-details-accordion');
    var detailsBody = document.getElementById('quick-view-details-body');
    var conditionAccordion = document.getElementById('quick-view-condition-accordion');
    var conditionBody = document.getElementById('quick-view-condition-body');
    var viewingAccordion = document.getElementById('quick-view-viewing-accordion');
    var relatedTrack = document.getElementById('quick-view-related-track');

    var images = [];
    var currentProduct = null;
    var currentVariant = null;
    var activeItem = null;
    var originalUrl = null;

    /* ── Money formatting (matches the rest of the site) ─────────── */
    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      var parts = amount.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return '$' + parts.join('.');
    }

    /* ── Gallery ───────────────────────────────────────────────── */
    function currentSlideIndex() {
      if (!galleryTrack || !galleryTrack.clientWidth) return 0;
      return Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth);
    }

    function goToSlide(index) {
      var slides = galleryTrack.querySelectorAll('img, video');
      if (!slides[index]) return;
      galleryTrack.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    function goToImageId(imageId) {
      var slides = Array.from(galleryTrack.querySelectorAll('img, video'));
      var index = slides.findIndex(function (slide) {
        return slide.dataset.imageId === String(imageId);
      });
      if (index > -1) goToSlide(index);
    }

    function updateGalleryUI() {
      var index = currentSlideIndex();
      Array.from(dotsEl.querySelectorAll('.quick-view__dot')).forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= images.length - 1;
    }

    function buildDots() {
      dotsEl.innerHTML = '';
      images.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'quick-view__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Media ' + (i + 1));
        dot.addEventListener('click', function () {
          goToSlide(i);
        });
        dotsEl.appendChild(dot);
      });
      controlsEl.style.display = images.length > 1 ? '' : 'none';
    }

    /* ── Variant selection ────────────────────────────────────────── */
    function getSelectedOptions() {
      var opts = [];
      Array.from(optionsEl.querySelectorAll('.quick-view__option-values')).forEach(function (group) {
        var checked = group.querySelector('.quick-view__option-radio:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return (
        currentProduct.variants.find(function (v) {
          return v.options.every(function (o, i) {
            return o === opts[i];
          });
        }) || null
      );
    }

    function renderPrice(variant) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML =
          '<span class="quick-view__price-sale">' +
          formatMoney(variant.price) +
          '</span><span class="quick-view__price-compare">' +
          formatMoney(variant.compare_at_price) +
          '</span>';
      } else {
        priceEl.textContent = formatMoney(variant.price);
      }
    }

    function updateVariant() {
      var opts = getSelectedOptions();
      var variant = currentProduct.hasOnlyDefaultVariant
        ? currentProduct.variants[0]
        : findVariant(opts);

      if (!variant) {
        currentVariant = null;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Select options';
        errorEl.textContent = 'Please select an option before adding to cart.';
        errorEl.hidden = false;
        return;
      }

      currentVariant = variant;
      renderPrice(variant);
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      errorEl.hidden = true;

      if (variant.featured_image) {
        goToImageId(variant.featured_image.id);
      }
    }

    function buildOptions(product) {
      optionsEl.innerHTML = '';
      if (product.hasOnlyDefaultVariant) return;

      product.options.forEach(function (option) {
        var group = document.createElement('div');
        group.className = 'quick-view__option';

        var label = document.createElement('p');
        label.className = 'quick-view__option-label';
        label.textContent = option.name;
        group.appendChild(label);

        var values = document.createElement('div');
        values.className = 'quick-view__option-values';

        option.values.forEach(function (value) {
          var wrap = document.createElement('label');
          wrap.className = 'quick-view__option-value';

          var radio = document.createElement('input');
          radio.type = 'radio';
          radio.name = 'quick-view-option-' + option.position;
          radio.value = value;
          radio.className = 'quick-view__option-radio';
          if (option.selected_value === value) radio.checked = true;
          radio.addEventListener('change', updateVariant);

          var text = document.createElement('span');
          text.className = 'quick-view__option-text';
          text.textContent = value;

          wrap.appendChild(radio);
          wrap.appendChild(text);
          values.appendChild(wrap);
        });

        group.appendChild(values);
        optionsEl.appendChild(group);
      });
    }

    /* ── Accordions ────────────────────────────────────────────── */
    function buildAccordions(data) {
      if (data.detailsHtml) {
        detailsBody.innerHTML = data.detailsHtml;
        detailsAccordion.hidden = false;
      } else {
        detailsBody.innerHTML = '';
        detailsAccordion.hidden = true;
        detailsAccordion.open = false;
      }
      if (data.conditionHtml) {
        conditionBody.innerHTML = data.conditionHtml;
        conditionAccordion.hidden = false;
      } else {
        conditionBody.innerHTML = '';
        conditionAccordion.hidden = true;
        conditionAccordion.open = false;
      }
      viewingAccordion.hidden = !data.showViewingAccordion;
    }

    /* ── Related products ──────────────────────────────────────── */
    function buildRelated(data) {
      relatedTrack.innerHTML = '';
      var related = data.related || [];

      related.forEach(function (item) {
        var link = document.createElement('a');
        link.href = item.url;
        link.className = 'product-card';
        link.dataset.url = item.url;

        var imagesWrap = document.createElement('div');
        imagesWrap.className = 'product-card__images';

        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = item.title;
          img.loading = 'lazy';
          img.className = 'product-card__image product-card__image--primary';
          imagesWrap.appendChild(img);
        } else {
          var placeholder = document.createElement('div');
          placeholder.className = 'product-card__image product-card__image--placeholder';
          imagesWrap.appendChild(placeholder);
        }

        var info = document.createElement('div');
        info.className = 'product-card__info';

        var title = document.createElement('p');
        title.className = 'product-card__title';
        title.textContent = item.title;

        var price = document.createElement('p');
        price.className = 'product-card__price';
        if (item.compareAtPrice && item.compareAtPrice > item.price) {
          price.innerHTML =
            '<span class="product-card__price--sale">' +
            formatMoney(item.price) +
            '</span><s class="product-card__price--compare">' +
            formatMoney(item.compareAtPrice) +
            '</s>';
        } else {
          price.textContent = formatMoney(item.price);
        }

        info.appendChild(title);
        info.appendChild(price);
        link.appendChild(imagesWrap);
        link.appendChild(info);

        link.addEventListener('click', function (e) {
          if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          if (!item.variants) return;
          e.preventDefault();
          populateFromData(item);
        });

        relatedTrack.appendChild(link);
      });
    }

    function hideCurrentFromRelated(data) {
      var cards = relatedTrack.querySelectorAll('.product-card');
      cards.forEach(function (card) {
        card.style.display = card.dataset.url === data.url ? 'none' : '';
      });
    }

    /* ── Populate + open/close ─────────────────────────────────── */
    function fillProduct(data, opts) {
      opts = opts || {};

      currentProduct = data;
      images =
        data.media && data.media.length
          ? data.media
          : data.images && data.images.length
            ? data.images
            : [];

      galleryTrack.innerHTML = '';
      galleryTrack.scrollLeft = 0;
      images.forEach(function (item) {
        var el;

        if (item.type === 'video') {
          el = document.createElement('video');
          el.controls = true;
          el.playsInline = true;
          el.preload = 'metadata';
          if (item.poster) el.poster = item.poster;

          (item.sources || []).forEach(function (source) {
            var sourceEl = document.createElement('source');
            sourceEl.src = source.url;
            if (source.mimeType) sourceEl.type = source.mimeType;
            el.appendChild(sourceEl);
          });
        } else {
          el = document.createElement('img');
          el.src = item.url;
          el.alt = data.title || '';
        }

        el.dataset.imageId = item.id;
        galleryTrack.appendChild(el);
      });

      buildDots();
      updateGalleryUI();
      titleEl.textContent = data.title || '';
      descEl.innerHTML = data.description || '';

      buildOptions(data);
      updateVariant();
      buildAccordions(data);
      if (!opts.keepRelated) buildRelated(data);
      hideCurrentFromRelated(data);

      if (data.url) history.replaceState(null, '', data.url);
    }

    function populate(index) {
      var data = products[index];
      if (!data) return;
      if (scrollEl) scrollEl.scrollTop = 0;
      fillProduct(data);
    }

    function populateFromData(data) {
      if (scrollEl) scrollEl.scrollTop = 0;
      var productEl = document.querySelector('#quick-view-scroll .quick-view__product');
      if (productEl) productEl.classList.add('is-swapping');
      setTimeout(function () {
        fillProduct(data, { keepRelated: true });
        if (productEl) productEl.classList.remove('is-swapping');
      }, 150);
    }

    function animateOpen(fromRect) {
      var cardRect = card.getBoundingClientRect();
      var scaleX = fromRect.width / cardRect.width;
      var scaleY = fromRect.height / cardRect.height;
      var translateX = fromRect.left + fromRect.width / 2 - (cardRect.left + cardRect.width / 2);
      var translateY = fromRect.top + fromRect.height / 2 - (cardRect.top + cardRect.height / 2);

      card.style.transition = 'none';
      card.style.transform =
        'translate(-50%, -50%) translate(' +
        translateX +
        'px, ' +
        translateY +
        'px) scale(' +
        scaleX +
        ', ' +
        scaleY +
        ')';
      card.style.opacity = '0';

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          card.style.transition = 'transform 0.5s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.3s ease';
          card.style.transform = 'translate(-50%, -50%)';
          card.style.opacity = '1';
        });
      });
    }

    function open(item) {
      var index;
      if (item.dataset.quickViewHandle) {
        index = products.findIndex(function (p) {
          return p.handle === item.dataset.quickViewHandle;
        });
        if (index === -1) return;
      } else {
        index = parseInt(item.dataset.quickViewIndex, 10);
        if (isNaN(index)) return;
      }

      if (window.HW && window.HW.closeArchiveOverlay) window.HW.closeArchiveOverlay();
      if (window.HW && window.HW.closeCartDrawer) window.HW.closeCartDrawer();

      activeItem = item;
      originalUrl = window.location.href;
      populate(index);

      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      var thumb = item.querySelector('img');
      var fromRect = (thumb || item).getBoundingClientRect();
      animateOpen(fromRect);
    }

    function close() {
      if (originalUrl) {
        history.replaceState(null, '', originalUrl);
        originalUrl = null;
      }

      if (activeItem) {
        var thumb = activeItem.querySelector('img');
        var toRect = (thumb || activeItem).getBoundingClientRect();
        var cardRect = card.getBoundingClientRect();
        var scaleX = toRect.width / cardRect.width;
        var scaleY = toRect.height / cardRect.height;
        var translateX = toRect.left + toRect.width / 2 - (cardRect.left + cardRect.width / 2);
        var translateY = toRect.top + toRect.height / 2 - (cardRect.top + cardRect.height / 2);

        card.style.transition = 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.3s ease';
        card.style.transform =
          'translate(-50%, -50%) translate(' +
          translateX +
          'px, ' +
          translateY +
          'px) scale(' +
          scaleX +
          ', ' +
          scaleY +
          ')';
        card.style.opacity = '0';
      }

      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';

      setTimeout(function () {
        card.style.transition = 'none';
        card.style.transform = 'translate(-50%, -50%)';
        card.style.opacity = '1';
        activeItem = null;
      }, 450);
    }

    triggers.forEach(function (item) {
      item.addEventListener('click', function (e) {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        open(item);
      });
    });

    closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    prevBtn.addEventListener('click', function () {
      goToSlide(currentSlideIndex() - 1);
    });
    nextBtn.addEventListener('click', function () {
      goToSlide(currentSlideIndex() + 1);
    });
    galleryTrack.addEventListener('scroll', updateGalleryUI, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') goToSlide(currentSlideIndex() - 1);
      if (e.key === 'ArrowRight') goToSlide(currentSlideIndex() + 1);
    });

    /* ── Add to cart ───────────────────────────────────────────── */
    submitBtn.addEventListener('click', function () {
      if (!currentVariant) {
        errorEl.textContent = 'Please select an option before adding to cart.';
        errorEl.hidden = false;
        return;
      }
      if (!currentVariant.available) return;

      var originalText = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';
      errorEl.hidden = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: currentVariant.id, quantity: 1 }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add-to-cart-failed');
          return fetch('/cart.js');
        })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var cartCountEl = document.getElementById('cart-count');
          if (cartCountEl) cartCountEl.textContent = cart.item_count;
          submitBtn.textContent = 'Added';
          setTimeout(function () {
            close();
            if (window.HW && window.HW.openCartDrawer) window.HW.openCartDrawer();
          }, 500);
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
          errorEl.textContent = "Something went wrong adding this to your cart — please try again.";
          errorEl.hidden = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
